import Vue from 'vue'
import App from './App.vue'
import femonitorVue from 'femonitor-vue';
import router from './router'
import emitter from '@/common/mixins/emitter'
import * as directives from '@/common/js/directive';
import './common/style/index.less'
// 全局非业务组件
import toast from '@/base/toast';
import fixedComponent from '@/base/fixedComponent'
import project from '@/common/js/project.js';

// videojs
import Video from 'video.js'
import 'video.js/dist/video-js.css'

// 全局业务组件
import components from '@/components'

// 工具方法
import * as http from '@/common/js/api'
import * as client from '@/common/js/client'
import * as utils from '@/common/js/utils'
import jsonp from 'vue-jsonp'
const thscSnsBaselib = window['thsc-sns-baselib'];
femonitorVue(Vue);
if(window.feMonitor){
    try{
        feMonitor.setConfig({
            slientDev: false,//开发环境(localhost)是否发送报错请求，默认不发送为true
            sampleRate: 0.01, //采样率,可设置0-1之间，越小采集的频率越低，默认为0.3，即采集30%,收费项目建议都设置成1
            isCollectPerformance: true, //采集性能，默认为false
            title:'资讯-newslist' //项目名称，没有该参数时会自动通过`document.title`拿html上面的title名称,如果同一个项目每个页面的title都不一样的话务必设置一个总的title来标识一下这个项目
        });
    } catch(e){}
}
Vue.use(jsonp)

import * as stats from '@/common/js/stats';
// Vue.prototype.$pcStat = stats.browserStat('pcnewsbrowser');
Vue.prototype.$pcStat = function(){};
// Vue.prototype.$pageStat = stats.PageStat('pcnewsbrowser');
Vue.prototype.$pageStat = function(){};
Vue.prototype.$sendStat = function(str, params = {}){
    params.id = str
    TA.log(  Object.assign(params,utils.getUrlParams()));
}

import {actionStats} from "@/common/js/points.js"
Vue.prototype.$sendPoint = function (params) {
    console.log('actionStats[params]', actionStats[params])
    TA.log({id: actionStats[params]});
}
Vue.prototype.$Video = Video;

// 为了埋点
window.statSeq = 0

Vue.prototype.$http = http;
Vue.prototype.$client = client;
Vue.prototype.$utils = {...utils, thscSnsBaselibUtils:thscSnsBaselib.utils};
Vue.prototype.$project = project;
Vue.prototype.$commonApi = commonApi; // 外部引入的对象 包含点击数、阅读数、点赞），行情接口等常用接口。
window.Vue = Vue
Object.keys(components).forEach(ele => {
    Vue.use(components[ele])
})
Vue.component( 'sns-scroll-load', thscSnsBaselib['sns-scroll-load'])
Vue.component( 'fixedComponent', fixedComponent)
Vue.mixin(emitter);
Vue.use(toast);
Vue.config.productionTip = false;
// 混入全局指令
Object.keys(directives).forEach( key => {
    Vue.directive( key, directives[key]())
})
window.vm = new Vue({
    // store,
    render: h => h(App),
    router,
}).$mount("#app")

